import { Colors as IColors } from '@/types/store';
import { isEqual } from 'lodash';
import { Colors } from '../constants/themeConstants';

/**
 * Finds the color collection ID that matches the provided colors.
 * Searches through predefined color collections and returns the ID of the matching one.
 *
 * @param colors - Optional colors object to match against color collections
 * @returns The ID of the matching color collection if found, otherwise undefined
 */
export const getColorCollection = (colors?: IColors) => {
    const colorCollection = Colors.find(c => {
        return isEqual(c.colors, colors);
    })?.id;

    return colorCollection;
};
